import React from 'react';

import styles from './troy.module.scss';
import UserInfoItemComponent from '../ProfileUserInfoItem/index.troy';

import UserInfo from '.';

const TroyUserInfo = props => (
  <UserInfo {...props} {...{ styles, UserInfoItemComponent }} />
);

TroyUserInfo.propTypes = {};

export default TroyUserInfo;
